export enum EPreferredUptBaseTypes {
  COLUMBUS = 'Columbus AFB, MS',
  LAUGHLIN = 'Laughlin AFB, TX',
  VANCE = 'Vance AFB, OK'
}
